import { render, staticRenderFns } from "./order_product_selector.vue?vue&type=template&id=2ddbf908&scoped=true"
import script from "./order_product_selector.vue?vue&type=script&lang=js"
export * from "./order_product_selector.vue?vue&type=script&lang=js"
import style0 from "./order_product_selector.vue?vue&type=style&index=0&id=2ddbf908&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddbf908",
  null
  
)

export default component.exports